<section class="dynamic-form" [class.dynamic-form--wide]="wide" [class.dynamic-form--with-back]="showBackActions">
    <div class="dynamic-form__layout-rail">
        <tec-button
            size="lg"
            type="secondary"
            class="dynamic-form__back-button dynamic-form__back-button--content-sizer"
            icon="icon-chevron-left"
            iconPosition="left"
            [label]="'GENERAL.BUTTON.GO_BACK' | translate"
            tabindex="-1"
            aria-hidden="true"
        />
        <div class="dynamic-form__header">
            <h3 class="dynamic-form__title">{{ stepTitle }}</h3>
            @if (stepDescription) {
                <p class="dynamic-form__description">{{ stepDescription }}</p>
            }
        </div>
    </div>

    <div class="dynamic-form__fields-panel" [formGroup]="stepForm">
        <div class="dynamic-form__fields">
            @for (field of visibleFields; track field.uuid) {
                <app-dynamic-form-field
                    [field]="field"
                    [stepForm]="stepForm"
                    [stepTitle]="stepTitle"
                    [visibleFieldCount]="visibleFields.length"
                    [resolveLocalizedText]="resolveLocalizedText"
                    [options]="fieldOptions(field)"
                    [selectPlaceholder]="selectPlaceholder(field)"
                    [selectSearch]="usesSelectSearch(field)"
                    [selectDisabled]="isSelectDisabled(field)"
                    [legalToggleOptions]="legalToggleOptions"
                    [showValidationErrors]="showValidationErrors"
                    (legalToggleChange)="legalToggleChange.emit($event)"
                    (fileSelected)="fileSelected.emit($event)"
                />
            }
        </div>
    </div>

    @if (apiError) {
        <p class="dynamic-form__error">{{ apiError | translate }}</p>
    }
</section>
